import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: ReactNode;
  desc?: string;
  align?: "left" | "center";
  action?: ReactNode;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  action,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div
      className={`mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end ${
        isCenter ? "md:flex-col md:items-center" : "md:justify-between"
      }`}
    >
      <div className={isCenter ? "text-center" : ""}>
        {eyebrow ? (
          <div
            className={`mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary-600 ${
              isCenter ? "justify-center" : ""
            }`}
          >
            <span className="h-[2px] w-6 bg-primary-500" aria-hidden="true" />
            {eyebrow}
          </div>
        ) : null}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h2>
        {desc ? (
          <p className={`mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base ${isCenter ? "mx-auto" : ""}`}>
            {desc}
          </p>
        ) : null}
      </div>
      {action && !isCenter ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}